// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2evCm","options":"AnswerScale_options__1l6i3","selected":"AnswerScale_selected__3XlUX"};